import React, { useState } from 'react';

const TransactionCountCard = ({ data, theme }) => {
  const [selectedTimeRange, setSelectedTimeRange] = useState('Last 30 Days');

  const timeRanges = ['Last 30 Days', 'Last 14 Days', 'Last 7 Days'];

  const handleTimeRangeChange = (e) => {
    setSelectedTimeRange(e.target.value);
  };

  const getTransactionCount = () => {
    if (!data) {
      return 0;
    }
    let count;
    switch (selectedTimeRange) {
      case 'Last 7 Days':
        count = data['Transaction Count Last 7 Days'];
        break;
      case 'Last 14 Days':
        count = data['Transaction Count Last 14 Days'];
        break;
      case 'Last 30 Days':
        count = data['Transaction Count Last 30 Days'];
        break;
      default:
        count = 0;
        break;
    }
    return count !== undefined && count !== null ? count : 0;
  };

  const transactionCount = getTransactionCount();

  return (
    <div className="h-full">
      {/* Header */}
      <div className="mb-4">
        <div className="flex items-center gap-2 mb-2">
          <div 
            className="w-3 h-3 rounded-full" 
            style={{ backgroundColor: theme.primary }}
          ></div>
          <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">
            Transactions
          </h3>
        </div>
        <select 
          id="timeRange" 
          onChange={handleTimeRangeChange} 
          value={selectedTimeRange}
          className="text-xs bg-gray-50 border border-gray-200 rounded-md px-2 py-1 text-gray-600 focus:ring-2 focus:ring-opacity-20 focus:outline-none"
          style={{ focusRing: theme.primary + '30' }}
        >
          {timeRanges.map((range) => (
            <option key={range} value={range}>
              {range}
            </option>
          ))}
        </select>
      </div>

      {/* Main Content */}
      <div className="flex flex-col items-center justify-center h-32">
        <div className="text-center">
          <div className="text-4xl font-bold text-gray-900 mb-2">
            {transactionCount !== null ? transactionCount.toLocaleString() : '—'}
          </div>
          <div className="text-xs text-gray-500 font-medium">
            Total Count
          </div>
        </div>
      </div>

      {/* Footer Indicator */}
      <div className="mt-4 pt-3 border-t border-gray-100">
        <div className="flex items-center justify-center gap-2">
          <div 
            className="w-1.5 h-1.5 rounded-full" 
            style={{ backgroundColor: theme.primary }}
          ></div>
          <span className="text-xs text-gray-500">
            {selectedTimeRange}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TransactionCountCard;
